@if (model.media?.uuid && !youtubeLink) {
<img
  src="https://s3.{{ mediaBucket.region }}.amazonaws.com/{{
    mediaBucket.name
  }}/{{ model.media.uuid }}.{{ model.media.file_ext }}"
  class="image"
/>
} @if (youtubeLink) {
<iframe
  [src]="youtubeLink"
  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
  allowfullscreen
></iframe>
} @if (model.media?.uuid) {
<button mat-icon-button (click)="showImage(model.media)" class="zoom-button">
  <mat-icon>zoom_in</mat-icon>
</button>
}
